const LOCAL_FEATURE_FLAGS_KEY = 'featureFlags';

export const isLocalFeatureFlagEnabled = (flag: string): boolean => {
  try {
    const flags = JSON.parse(localStorage.getItem(LOCAL_FEATURE_FLAGS_KEY) ?? '{}');
    return flags?.[flag] === true;
  } catch {
    return false;
  }
};
